// extracted by mini-css-extract-plugin
module.exports = {"chevron":"_35875ce240--chevron--rU0Lz","chevron--opened":"_35875ce240--chevron--opened--bvtwx"};